import {
    Create,
    SimpleForm,
    TextInput,
    NumberInput,
    SaveButton,
    Toolbar,
} from 'react-admin';
import { required } from 'react-admin';

const CreateToolbar = () => (
    <Toolbar>
        <SaveButton />
    </Toolbar>
);

const ValkeyCreate = () => (
    <Create>
        <SimpleForm toolbar={<CreateToolbar />}>
            <TextInput
                source="key"
                label="resources.valkey.fields.key"
                validate={[required()]}
                fullWidth
            />
            <TextInput
                source="value"
                label="resources.valkey.fields.value"
                validate={[required()]}
                multiline
                rows={10}
                fullWidth
            />
            <NumberInput
                source="ttl"
                label="resources.valkey.fields.ttl"
                helperText="TTL sekunteina. Jätä tyhjäksi jos ei halua vanhenemista."
            />
        </SimpleForm>
    </Create>
);

export default ValkeyCreate;
